import { makeStyles } from '@material-ui/styles';

const loadingStyles = makeStyles({
  container: {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 999999,
    position: 'fixed',
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
  },
  spinner: {
    zIndex: 999999,
    width: '50px',
    height: '50px',
    borderRadius: '80%',
    borderBottom: '13px solid #D12E2E',
    borderTop: '13px solid #0079E6',
    borderLeft: '13px solid #3A9E12',
    borderRight: '13px solid #FB9600',
    WebkitAnimation: '$spinnerAnimation 2s linear infinite',
    animation: '$spinnerAnimation 0.5s linear infinite',
    boxShadow: '0px 0.3px 4px 0px black',
  },
  message: {
    textAlign: 'center',
    marginTop: '40px',
    padding: '0 16px',

    '& p': {
      fontSize: '1.7rem',
      fontWeight: 'bold',
    },
    '& p + p': {
      marginTop: '2rem',
    },
  },
  '@keyframes spinnerAnimation': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  },
});

export { loadingStyles };
